import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const CruiseIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M1.80346 10.5435H11.2308C11.9284 10.5435 12.2024 10.0493 12.2813 9.6612C12.3089 9.5259 12.4196 9.41304 12.5577 9.41304H12.8462M1.80346 10.5435H1.32191C1.15873 10.5435 1.0393 10.6973 1.07971 10.8554L1.5 12.5L2.0248 14.3193C2.05567 14.4263 2.15362 14.5 2.265 14.5H12.3077C13.009 14.5 14.4982 13.5292 14.9683 9.69072C14.9864 9.54334 14.8706 9.41304 14.7221 9.41304H12.8462M3.15385 4.8913H2.83204C2.7077 4.8913 2.60226 4.98268 2.58458 5.10576L2.29061 7.15217L1.80346 10.5435M10.1538 7.15217L9.1448 5.03379C9.10333 4.94675 9.01551 4.8913 8.91909 4.8913H6.92308M10.1538 7.15217H11.6114C11.7078 7.15217 11.7956 7.20762 11.8371 7.29466L12.8462 9.41304M10.1538 7.15217H2.29061M3.15385 4.8913V1.75C3.15385 1.61193 3.26577 1.5 3.40385 1.5H4.63185C4.7174 1.5 4.79702 1.54375 4.84288 1.61597L6.92308 4.8913M3.15385 4.8913H6.92308"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M1.5 12.5H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="3.5" y="8.5" width="1" height="1" rx="0.5" fill="currentColor" />
    <rect x="5.5" y="8.5" width="1" height="1" rx="0.5" fill="currentColor" />
    <rect x="7.5" y="8.5" width="1" height="1" rx="0.5" fill="currentColor" />
    <rect x="9.5" y="8.5" width="1" height="1" rx="0.5" fill="currentColor" />
  </svg>
));
